import { ContactComponent } from "./contact/contact.component";

export default {
  ContactComponent,
};

export const COMPONENTS = [ContactComponent];
